import * as React from 'react';
const SvgPersonCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M12 3a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 3m5.43 13.41c-1.6-1.22-3.45-1.91-5.43-1.91s-3.83.7-5.43 1.91A6.995 6.995 0 0 1 12 5a6.995 6.995 0 0 1 5.43 11.41"
    />
    <path
      fill="currentColor"
      d="M13.39 7.41A2.5 2.5 0 0 0 12 7c-.51 0-.97.14-1.39.41s-.75.63-1 1.08c-.24.45-.36.94-.36 1.48 0 .58.12 1.09.36 1.55s.57.82.98 1.08c.41.27.88.4 1.4.4s.99-.13 1.41-.4q.63-.405.99-1.08c.24-.45.36-.97.36-1.55 0-.54-.12-1.03-.37-1.48q-.375-.675-.99-1.08"
    />
  </svg>
);
export default SvgPersonCircle;
